import { createI18n } from 'vue-i18n'

// 定义翻译内容
const messages = {
  'zh-Hant': {
    home: '首页',
    productCategory: '產品分類',
    contactUs: '聯絡我們',
    aboutUs: '關於我們',
    productCatalog: '產品目錄',
    homeChargingSolutions: '家用充電方案',
    evCharging: 'EV 屋苑充電易',
    commercialChargingSolutions: '商用充電方案',
    engineeringProjects: '工程項目',
    latestNews: '最新消息',
    approved: '已批准',
    completed: '已完成',
    applicationProcess: '申程港流程',
    faq: '常見問題',
    electricMotorcycles: '電動摩托車',
    motorcycleParts: '電動摩托車配件',
    batteryExchange: '電動摩托車換電櫃',
    evChargers: 'EV充電椿',
    evCables: 'EV充電線',
    evAdapters: 'EV充電轉接頭',
    traditionalChinese: '繁體中文',
    english: '英文',
    contactTitle: '聯絡我們',
    startNavigation: '開始導航',
    phone1: '852 2111 9678',
    phone2: '852 6686 0815',
    email: 'cs@drmotor.hk', // 移除不必要的转义
    address: '觀塘海濱道151號廣生行地下6號舖',
    footer: 'Footer',
    contactDesc: '無論您有任何查詢或建議，歡迎隨時與我們聯繫',
    phone: '電話',
    whatsappWechat: 'WhatsApp/微信',
    emailLabel: '電子郵件',
    addressLabel: '地址',
    followUs: '關注我們',
    facebook: 'Facebook',
    whatsapp: 'WhatsApp',
    instagram: 'Instagram',
    // 体验申请表单翻译
    applicationForm: '體驗申請表',
    englishName: '英文全名',
    chineseName: '中文全名',
    applicationEmail: '電子郵件',
    phoneNumber: '手機號碼',
    applicationAddress: '地址',
    remarks: '備註',
    inputEnglishName: '請輸入英文全名',
    inputChineseName: '請輸入中文全名',
    inputEmail: '請輸入電子郵件地址',
    inputPhone: '請輸入手機號碼',
    inputAddress: '請輸入地址',
    inputRemarks: '請輸入備註信息',
    submit: '提交保存',
    submitting: '提交中...',
    goBack: '返回',
    submitSuccess: '申請提交成功！',
    submitFailed: '提交失敗，請稍後重試。',
    // 底部导航栏翻译
    footerProducts: '產品',
    footerCommercialSolutions: '商業解決方案',
    footerQuickLinks: '快速鏈接',
    footerSubscribe: '訂閱',
    subscribeDescription: '隨時了解我們的新產品、最熱門的優惠和活動。',
    yourEmail: '您的電子郵件',
    subscribeButton: '訂閱',
    tiktok: '抖音'
  },
  'en': {
    home: 'Home',
    productCategory: 'Products',
    contactUs: 'Contact Us',
    aboutUs: 'About Us',
    productCatalog: 'Product Catalog',
    homeChargingSolutions: 'Home Charging Solutions',
    evCharging: 'EV Building Charging Easy',
    commercialChargingSolutions: 'Commercial Charging Solutions',
    engineeringProjects: 'Engineering Projects',
    latestNews: 'Latest News',
    approved: 'Approved',
    completed: 'Completed',
    applicationProcess: 'Application Process',
    faq: 'FAQ',
    electricMotorcycles: 'Electric Motorcycles',
    motorcycleParts: 'Motorcycle Parts',
    batteryExchange: 'Battery Exchange',
    evChargers: 'EV Chargers',
    evCables: 'EV Cables',
    evAdapters: 'EV Adapters',
    traditionalChinese: 'Traditional Chinese',
    english: 'English',
    contactTitle: 'Contact Us',
    startNavigation: 'Start Navigation',
    phone1: '852 2111 9678',
    phone2: '852 6686 0815',
    email: 'cs@drmotor.hk', // 移除不必要的转义
    address: 'Shop 6, G/F, Kwong Sang Hong Building, 151 Kwun Tong Promenade, Kwun Tong',
    footer: 'Footer',
    contactDesc: 'If you have any questions or suggestions, please feel free to contact us',
    phone: 'Phone',
    whatsappWechat: 'WhatsApp/WeChat',
    emailLabel: 'Email',
    addressLabel: 'Address',
    followUs: 'Follow Us',
    facebook: 'Facebook',
    whatsapp: 'WhatsApp',
    instagram: 'Instagram',
    // 体验申请表单翻译
    applicationForm: 'Experience Application',
    englishName: 'English Full Name',
    chineseName: 'Chinese Full Name',
    applicationEmail: 'Email',
    phoneNumber: 'Phone Number',
    applicationAddress: 'Address',
    remarks: 'Remarks',
    inputEnglishName: 'Please enter English full name',
    inputChineseName: 'Please enter Chinese full name',
    inputEmail: 'Please enter email address',
    inputPhone: 'Please enter phone number',
    inputAddress: 'Please enter address',
    inputRemarks: 'Please enter remarks',
    submit: 'Submit',
    submitting: 'Submitting...',
    goBack: 'Back',
    submitSuccess: 'Application submitted successfully!',
    submitFailed: 'Submission failed, please try again later.',
    // Footer translations
    footerProducts: 'Products',
    footerCommercialSolutions: 'Commercial Solutions',
    footerQuickLinks: 'Quick Links',
    footerSubscribe: 'Subscribe',
    subscribeDescription: 'Stay updated with our new products, hottest offers and events.',
    yourEmail: 'Your Email',
    subscribeButton: 'Subscribe',
    tiktok: 'TikTok'
  }
}

// 创建i18n实例
const i18n = createI18n({
  legacy: false, // 使用Composition API必须设置legacy为false
  locale: 'zh-Hant', // 默认语言为繁体中文
  fallbackLocale: 'en', // 回退语言为英文
  messages
})

export default i18n